module.exports = __webpack_public_path__ + "img/icon_candidate_verified_animated.e4452feb.gif";